import { useToggle } from 'admin';
import { ActionBar, SampleCard } from 'features';
import { Box, List, ListItem } from 'ui';

import { useManageSamples } from '../../hooks/useManageSamples/useManageSamples';
import { SampleMaterialEditDialog } from '../SampleMaterialEditDialog/SampleMaterialEditDialog';

export const SampleListSelect = ({ siteMaterialId, onClose }: { siteMaterialId: string; onClose?: () => void }) => {
  const { open, isOpen, close } = useToggle();
  const { samples, selected, select, isSelected, setSelected, updateSelected, deleteSelected } = useManageSamples({
    onClose,
    siteMaterialId,
  });
  return (
    <>
      {selected.length > 0 && (
        <ActionBar
          selected={selected.length}
          handleClose={() => setSelected([])}
          handleDelete={deleteSelected}
          handleMove={open}
        />
      )}

      <List>
        {samples.map((sample) => (
          <ListItem key={sample.id} onClick={() => select(sample.id)} sx={{ px: 0 }}>
            <Box width="100%">
              <SampleCard sample={sample} isSelected={isSelected(sample.id)} />
            </Box>
          </ListItem>
        ))}
      </List>

      <SampleMaterialEditDialog open={isOpen} onClose={close} onSubmit={updateSelected} />
    </>
  );
};
